import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useBrandManager } from '@/hooks/useBrandManager';

export interface DocHubPhoto {
  id: string;
  url: string;
  name: string;
  created_at: string;
}

export const useDocHubPhotos = () => {
  const { currentBrandId: brandId } = useBrandManager();

  const { data: photos = [], isLoading, error } = useQuery({
    queryKey: ['doc-hub-photos', brandId],
    queryFn: async () => {
      if (!brandId) return [];
      
      const { data, error } = await supabase
        .from('os_doc_hub_photos')
        .select('id, photos, name, created_at')
        .eq('brand_id', brandId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      // Flatten the photos arrays from all records
      const flattenedPhotos: DocHubPhoto[] = [];
      
      (data || []).forEach(record => {
        const photosArray = record.photos as string[] | null;
        if (photosArray && Array.isArray(photosArray)) {
          photosArray.forEach((photoUrl, index) => {
            flattenedPhotos.push({
              id: `${record.id}-${index}`,
              url: photoUrl,
              name: record.name || `Photo ${index + 1}`,
              created_at: record.created_at,
            });
          });
        }
      });
      
      return flattenedPhotos;
    },
    enabled: !!brandId,
  });

  return {
    photos,
    isLoading,
    error,
  };
};
